// Example Firestore helpers for categories/subcategories
import { db } from "../firebase";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

export const getAllCategoriesDoc = () => doc(db, "Categories/AllCategories");

export const getSubcategories = async (section) => {
  const docRef = getAllCategoriesDoc();
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data()[section] || [];
  }
  return [];
};

export const setSubcategories = async (section, subcategories) => {
  const docRef = getAllCategoriesDoc();
  try {
    await updateDoc(docRef, { [section]: subcategories });
  } catch (e) {
    await setDoc(docRef, { [section]: subcategories }, { merge: true });
  }
};

export const deleteSubcategory = async (section, subcategory) => {
  const docRef = getAllCategoriesDoc();
  const docSnap = await getDoc(docRef);
  if (!docSnap.exists()) return [];
  const current = docSnap.data()[section] || [];
  const updated = current.filter(s => s !== subcategory);
  await setSubcategories(section, updated);
  return updated;
};